import { GET_BUS_CONTROL_SETTINGS } from '../actions/getBusControlSettings';
import { LOGOUT_ACTION } from 'modules/general/shared/action/logout';

const initialState = {
  initialized: false,
  controlSettingsData: {
    isEnableGoShow: false,
  },
};

export default function busControlSettingsReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case GET_BUS_CONTROL_SETTINGS:
      return { ...action.payload, initialized: true };
    case LOGOUT_ACTION:
      return initialState;
    default:
      return state;
  }
}
